import GavelIcon from "@mui/icons-material/Gavel";
import ListAuctions from "./List";
import EditAuctions from "./Edit";
import CreateAuctions from "./Create";
import ShowAuctions from "./Show";
//params
export const AUCTIONS = "auctions";

//permissions

export const resources = {
  isMenu: true,
  icon: <GavelIcon />,
  name: AUCTIONS,
  title: "Търгове-наеми/продажби",
  list: <ListAuctions />,
  edit: <EditAuctions />,
  create: <CreateAuctions />,
  show: <ShowAuctions />,
  permission: "auctions",
};

//api url
